import React from 'react'
import { Box, Divider, Typography } from '@material-ui/core'
import currency from 'currency.js'

const PriceRow = ({ label, value, primary = false, negativeValue = false, hide = false }) => (
  <Box display={hide ? 'none' : 'flex'} justifyContent="space-between">
    <Typography variant={primary ? 'h5' : 'body1'}>{label}</Typography>
    <Typography variant={primary ? 'h5' : 'body1'}>
      {negativeValue && '- '}
      {typeof value === 'number' ? currency(value, { formatWithSymbol: true }).format() : value}
    </Typography>
  </Box>
)

const SubtotalPreTax = ({
  couponAmount,
  couponApplied,
  couponCode,
  creditsApplied,
  creditsUsed,
  deliveryFee,
  subtotal,
}) => {
  const isFreeDelivery = deliveryFee === 0
  return (
    <>
      <PriceRow
        label={
          <>
            Delivery Fee
            {isFreeDelivery && (
              <img
                alt=""
                src="https://images.foodsby.com/conweb/subscription-car-new-red.png"
                style={{ margin: '0px 8px 2px 8px', verticalAlign: 'middle' }}
                width="36px"
              />
            )}
          </>
        }
        value={isFreeDelivery ? 'FREE' : deliveryFee}
      />
      <PriceRow
        label={`Coupon ${couponCode}`}
        value={couponAmount}
        negativeValue
        hide={!couponApplied}
      />
      <PriceRow label="Credit" value={creditsUsed} negativeValue hide={!creditsApplied} />
      <PriceRow label="Subtotal" value={subtotal} />
    </>
  )
}

const SubtotalPostTax = ({
  programAmount,
  programApplied,
  programCode,
  storedCurrencyAmount,
  storedCurrencyApplied,
  taxes = 0,
}) => {
  return (
    <>
      <PriceRow label="Taxes" value={taxes} />
      <PriceRow label={programCode} value={programAmount} negativeValue hide={!programApplied} />
      <PriceRow
        label="Gift"
        value={storedCurrencyAmount / 100}
        negativeValue
        hide={!storedCurrencyApplied}
      />
    </>
  )
}

const PriceBreakdown = props => {
  const { orderTotal } = props
  return (
    <>
      <SubtotalPreTax {...props} />
      <Box marginY={3}>
        <Divider />
      </Box>
      <SubtotalPostTax {...props} />
      <Box marginY={3}>
        <Divider />
      </Box>
      <PriceRow primary label="Total" value={orderTotal} />
    </>
  )
}

export default PriceBreakdown
